export default __webpack_public_path__ + "locales/it/Payments.json?hash=5186322ebebed1bdbe74edf6a3c3feb3";